import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.map";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { chromaToIntervals, EmptyPcset } from '@tonaljs/pcset';
var DATA = [[0, 2773, 0, "ionian", "", "Maj7", "major"], [1, 2902, 2, "dorian", "m", "m7"], [2, 3418, 4, "phrygian", "m", "m7"], [3, 2741, -1, "lydian", "", "Maj7"], [4, 2774, 1, "mixolydian", "", "7"], [5, 2906, 3, "aeolian", "m", "m7", "minor"], [6, 3434, 5, "locrian", "dim", "m7b5"]];

var NoMode = _objectSpread({}, EmptyPcset, {
  name: "",
  alt: 0,
  modeNum: NaN,
  triad: "",
  seventh: "",
  aliases: []
});

var all = DATA.map(toMode);
var index = {};
all.forEach(function (mode) {
  index[mode.name] = mode;
  mode.aliases.forEach(function (alias) {
    index[alias] = mode;
  });
});
/**
 * Get a Mode by it's name
 *
 * @example
 * mode('dorian')
 * // =>
 * // {
 * //   intervals: [ '1P', '2M', '3m', '4P', '5P', '6M', '7m' ],
 * //   modeNum: 1,
 * //   chroma: '101101010110',
 * //   normalized: '101101010110',
 * //   name: 'dorian',
 * //   setNum: 2902,
 * //   alt: 2,
 * //   triad: 'm',
 * //   seventh: 'm7',
 * //   aliases: []
 * // }
 */

function mode(name) {
  return typeof name === "string" ? index[name.toLowerCase()] || NoMode : name && name.name ? mode(name.name) : NoMode;
}
/**
 * Get a list of all know modes
 */


function entries() {
  return all.slice();
}

function toMode(mode) {
  var _mode = _slicedToArray(mode, 7),
      modeNum = _mode[0],
      setNum = _mode[1],
      alt = _mode[2],
      name = _mode[3],
      triad = _mode[4],
      seventh = _mode[5],
      alias = _mode[6];

  var aliases = alias ? [alias] : [];
  var chroma = Number(setNum).toString(2);
  var intervals = chromaToIntervals(chroma);
  return {
    empty: false,
    intervals: intervals,
    modeNum: modeNum,
    chroma: chroma,
    normalized: chroma,
    name: name,
    setNum: setNum,
    alt: alt,
    triad: triad,
    seventh: seventh,
    aliases: aliases
  };
}

export { entries, mode };